





















import { Component, Vue } from 'vue-property-decorator'
import SlideBar from '@/apps/open/views/fileCenter/components/SlideBar.vue'
import DocRate from './components/DocRate.vue'
@Component({
  components: {
    SlideBar,
    DocRate
  }
})
export default class EnterpriseInnerApp extends Vue {
  fileCenterMenu = [
    {
      path: '/docs/doc-ai-open/access-know',
      name: '接入须知',
      icon: ''
    },
    {
      path: '/docs/doc-ai-open/api-auth',
      name: '接口鉴权',
      icon: ''
    },
    {
      path: '/docs/doc-ai-open/NLP',
      name: '自然语言处理技术',
      icon: '',
      children: [
        {
          path: '/docs/doc-ai-open/NLP/generic-word',
          name: '上下位词',
          icon: ''
        },
        {
          path: '/docs/doc-ai-open/NLP/keyword-extraction',
          name: '关键词提取',
          icon: ''
        },
        {
          path: '/docs/doc-ai-open/NLP/synonym',
          name: '近义词发散',
          icon: ''
        },
        {
          path: '/docs/doc-ai-open/NLP/topic-extraction',
          name: '主题句提取',
          icon: ''
        },
        {
          path: '/docs/doc-ai-open/NLP/text-summary',
          name: '文本摘要',
          icon: ''
        },
        {
          path: '/docs/doc-ai-open/NLP/new-word-descovery',
          name: '新词发现',
          icon: ''
        }
      ]
    },
    {
      path: '/docs/doc-ai-open/intelligent-write',
      name: '智能写作技术',
      icon: '',
      children: [
        {
          path: '/docs/doc-ai-open/intelligent-write/material-recommand',
          name: '素材推荐',
          icon: ''
        },
        {
          path: '/docs/doc-ai-open/intelligent-write/text-generate',
          name: '文本生成',
          icon: ''
        },
        {
          path: '/docs/doc-ai-open/intelligent-write/text-check',
          name: '文本校对',
          icon: ''
        },
        {
          path: '/docs/doc-ai-open/intelligent-write/tang-poem-generate',
          name: '唐诗自动生成',
          icon: ''
        },
        {
          path: '/docs/doc-ai-open/intelligent-write/song-poem-generate',
          name: '宋词自动生成',
          icon: ''
        }
      ]
    },
    {
      path: '/docs/doc-ai-open/produce-exp',
      name: '产品体验',
      icon: ''
    },
    {
      path: '/docs/doc-ai-open/error-code',
      name: '常见错误码',
      icon: ''
    },
    {
      path: '/docs/doc-ai-open/charge-standard',
      name: '计费方式',
      icon: ''
    }
  ];
  sliderBarOpeneds = ['', '']
  slideBarActive = ''
  breadList = []
  dropdownList = []
  dropdownSelectUrl = ''

  created () {
    this.initSlideBar(this.$route.path)
    this.initBreadcrumb(this.$route)
  }

  beforeRouteUpdate (to: any, from: any, next: any) {
    this.initSlideBar(to.path)
    this.initBreadcrumb(to)
    next()
  }

  mounted () {
    window.addEventListener('scroll', this.onBodyScroll, true)
  }

  beforeDestroy () {
    window.removeEventListener('scroll', this.onBodyScroll, true)
  }

  onBodyScroll () {
    let scrollTop = document.body.scrollTop + document.documentElement.scrollTop
    let elHeaderHeight = document.getElementsByClassName('el-header')[0].clientHeight
    let elAside = document.getElementsByClassName('el-aside')[0] as HTMLElement
    let elMain = document.getElementsByClassName('el-main')[0] as HTMLElement
    let elBreadCrumb = document.getElementsByClassName('el-breadcrumb')[0] as HTMLElement

    if (scrollTop > elHeaderHeight) {
      elAside.style.position = 'fixed'
      elAside.style.top = '66px'
      elMain.style.marginLeft = '231px'
      elBreadCrumb.style.position = 'fixed'
      elBreadCrumb.style.top = '66px'
    } else {
      elAside.style.position = 'relative'
      elAside.style.top = '0px'
      elMain.style.marginLeft = '0px'
      elBreadCrumb.style.position = 'relative'
      elBreadCrumb.style.top = '0px'
    }
  }

  initSlideBar (toIndex: string) {
    this.slideBarActive = toIndex
  }

  initBreadcrumb (curRoute: any) {
    let matched = curRoute.matched.filter((item: any) => item.meta.title)
    this.breadList = matched
    this.dropdownList = curRoute.meta.aimtilelist
  }

  dropdownItemOnclick (index: number) {
    this.dropdownSelectUrl = '#s' + index
  }
}
